import { makeStyles } from "@material-ui/core";

export const DieselCardCss = makeStyles(() => ({

    addTruckButton: {
        height: '36px',
        marginTop: '8px',
        padding: '7px 40px',
        borderRadius: '4px',
        backgroundColor: '#00875a',
        color: 'white',
        boxShadow: 'none !important',
        textTransform: 'none',
        '&:hover': {
            backgroundColor: '#00875a'
        }
    },
    textV1: {
        fontSize: '20px',
        color: 'rgba(11, 19, 35, 0.75)',
        marginTop: 24
    },
    divEmptyState: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center'
    },
    paperEmptyState: {
        borderRadius: 4,
        padding: '48px 24px',
        boxShadow: 'none !important',
    },
    gridContainerV1: {
        padding: "15px"
    },
    mt8: {
        marginTop: 8
    },
    pl8: {
        paddingLeft: 8
    },
    vehileNumber: {
        fontWeight: 'bold'
    },
    divAlign: {
        display: 'flex',
        alignItems: 'center'
    },
    activateButton: {
        border: '1px solid #0033cc',
        fontWeight: 'bold',
        textTransform: 'none',
        fontSize: 12,
        borderRadius: 4,
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 29,
        paddingRight: 29,
        color: '#0033cc'
    },
    paperV1: {
        padding: 24,
        paddingTop: 0,
        boxShadow: 'none !important',
        height: '100%'
    },
    mlV1: {
        marginLeft: 4
    },
    orangeColor: {
        color: '#e86825'
    },
    blueColor: {
        color: '#2c5de5'
    },
    marketLabel: {
        backgroundColor: '#e86825',
        color: 'white',
        fontSize: 10,
        borderRadius: 4,
        padding: '3.8px 4.5px 3.9px 5px',
        marginLeft: 8,
        textTransform: 'none'
    },
    ownLabel: {
        backgroundColor: '#0033cc',
        color: 'white',
        fontSize: 10,
        borderRadius: 4,
        paddingLeft: 4,
        paddingRight: 4,
        paddingTop: 2,
        paddingBottom: 2,
        marginLeft: 8,
        textTransform: 'none'
    },
    circle: {
        borderRadius: "50%",
        backgroundColor: "#c7c7c7",
        fontSize: 8,
        color: "#c7c7c7",
        marginLeft: 8,
        marginRight: 8
    },
    rechargeButton: {
        backgroundColor: '#0033cc',
        color: 'white',
        fontWeight: 'bold',
        textTransform: 'none',
        fontSize: 12,
        borderRadius: 4,
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 27,
        paddingRight: 27,
        boxShadow: "none !important",
        '&:hover': {
            backgroundColor: '#0033cc'
        }
    },
    gridContainerV2: {
        paddingLeft: 8,
        width: 'fit-content'
    },
    paperRecharge: {
        borderRadius: '8px',
        backgroundColor: 'white',
        marginBottom: '8px',
        boxShadow: 'none !important',
        cursor: 'pointer',
        "&:hover": {
            backgroundColor: '#F8F8F8'
        }
    },
    divAlignV1: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    divFooterV1: {
        paddingTop: '7px',
        paddingBottom: '7px',
        paddingLeft: '24px',
        paddingRight: '12px',
        backgroundColor: '#0b1323',
        color: 'white',
        fontSize: 14,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 8
    },
    rechargeProfit: {
        fontSize: 16,
        fontWeight: 600,
        textAlign: 'left',
        marginTop: 2,
        color: '#008556'
    },
    rechargeAmount: {
        fontSize: 16,
        fontWeight: 600,
        textAlign: 'left',
        marginTop: 2,
    },
    cashbackAmountText: {
        color: '#2c5de5',
        fontSize: 16,
        fontWeight: 600,
        marginTop: 2,
        textAlign: 'right'
    },
    titleV1: {
        fontSize: 12,
        color: '#0b1323'
    },
    divContainer: {
        padding: '20px 20px'
    },
    textAlignLeft: {
        textAlign: 'left'
    },
    textAlignRight: {
        textAlign: 'right'
    }

}))
